// This is the main page component. It's now much cleaner, focusing on layout and passing data down.

import React, { useState } from "react";
import { useProjectsDashboard } from "@/hooks/useProjectsDashboard";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { ProjectTable } from "@/components/dashboard/ProjectTable";
import { ym } from "@/App"; // Assuming ym is a utility function: const ym = (d) => d.toISOString().slice(0, 7);

function ProjectsDashboardPage() {
    const [month, setMonth] = useState(ym(new Date()));
    const { data, isLoading, error, actions } = useProjectsDashboard(month);

    return (
        <div className="flex flex-col h-full p-4 gap-6">
            <DashboardHeader
                month={month}
                setMonth={setMonth}
                dashboardData={data}
                actions={actions}
                isLoading={isLoading}
            />

            {error && (
                <div className="text-destructive text-center p-4 bg-destructive/10 rounded-md">
                    Error: {error}
                </div>
            )}

            <ProjectTable
                projects={data?.rows || []}
                isLoading={isLoading}
                actions={actions}
            />
        </div>
    );
}

export default ProjectsDashboardPage;
